import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

export const setConsignmentsAsAccounted = async consignmentsIds => {
  const response = await requestFunnel.patch('consignments/account', { consignmentsIds }, getOptions());
  return response.data;
};

export const createConsignment = async payments => {
  const response = await requestFunnel.post('consignments', { payments }, getOptions());
  return response.data;
};

export const getConsignmentsByDate = async (from, to) => {
  const response = await requestFunnel.get(`consignments?from=${from}&to=${to}`, getOptions());
  return response.data;
};
